import { Button } from 'components/core';
import { useRouter } from 'next/router';
import { BaseErrorContainer } from 'styles/sharedStyles';
import { useI18n } from 'contexts/i18n';

export const ProductNotFound = () => {
  const router = useRouter();
  const i18n = useI18n();
  return (
    <BaseErrorContainer>
      This product is currently unavailable in your country. <br /> For any
      product-related inquiries, please contact customer support.
      <br />
      <br />
      <Button
        size="xl"
        onClick={() => {
          router.push('/dso');
        }}
      >
        {i18n['Return To Shop']}
      </Button>
    </BaseErrorContainer>
  );
};
